import React from 'react';
import { Helmet } from "react-helmet";
import { Smartphone, Code, Briefcase, TrendingUp } from "lucide-react";

const PowerPlatformServices = () => {
  return (
    <section className="tech-services-section">
      <Helmet>
        <title>Microsoft Power Platform Services | Pravisht Digital</title>
        <meta
          name="description"
          content="Unlock the potential of Microsoft Power Platform with Pravisht Digital. Low-code apps, automation, BI, chatbots & Dataverse integration for business growth."
        />
        <meta
          name="keywords"
          content="Microsoft Power Platform, Power Apps, Power Automate, Power BI, Power Virtual Agents, Dataverse, low-code solutions, automation, Pravisht Digital"
        />
        <meta property="og:title" content="Microsoft Power Platform Services | Pravisht Digital" />
        <meta
          property="og:description"
          content="Unlock the potential of Microsoft Power Platform with Pravisht Digital. Low-code apps, automation, BI, chatbots & Dataverse integration for business growth."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/testing_pravisht.jpg" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>
      <div className="breadcrumb">
        <a href="/" className="mx-1">Home</a> &gt; <span className="mx-1">Microsoft Power Platform Services</span>
      </div>

      <div className="about-heading-section">
        <h1>Microsoft Power Platform Services</h1>
        <p>
          Unlock the full potential of your enterprise data and automate business processes with the Microsoft Power Platform. At Pravisht, we empower organisations to build intelligent apps, drive insights, and improve productivity with low-code, scalable solutions on Power Platform.
        </p>
      </div>

      <div className="about-image-fullscreen">
        <img src="/testing_pravisht.jpg" alt="Microsoft Power Platform by Pravisht" />
      </div>

      <div className="core-offerings">
        <div className="how-we-help__content">
          <p className="how-we-help__description services-desc">Our Services</p>
          <h1 className="how-we-help__title">Our Power Platform Capabilities</h1>
          <hr className="portfolio-horizontalline" />
        </div>

        <div className="offerings-grid">
          <div className="offering-card app-dev-card">
            <h4>⚡ Power Apps</h4>
            <p>
              Design low-code, scalable business apps that connect seamlessly with Microsoft 365, Dynamics, and third-party systems—transforming ideas into solutions.
            </p>
          </div>

          <div className="offering-card consulting-card">
            <h4>⚙️ Power Automate</h4>
            <p>
              Automate tasks and complex workflows with AI, RPA, and 500+ prebuilt connectors across your enterprise apps.
            </p>
          </div>

          <div className="offering-card automation-card">
            <h4>📊 Power BI</h4>
            <p>
              Turn data into actionable insights with interactive dashboards, real-time reporting, and deep integration across platforms like Excel, SQL, and SharePoint.
            </p>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>💬 Power Virtual Agents</h4>
            <p>
              Build intelligent, no-code chatbots for Teams, websites, and service channels with natural language capabilities to enhance support and engagement.
            </p>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>🗄️ Dataverse Integration</h4>
            <p>
              Unify and securely store business data with Dataverse—enabling seamless integration with Dynamics 365, Azure, and custom apps.
            </p>
          </div>
        </div>
      </div>

      <div className="engagement-layers-and-why-choose" style={{ backgroundColor: '#f1f4f3', marginBottom: '60px' }}>
       
          <h3 className="section-subtitle">Consulting & Implementation Services</h3>
          <p>We offer end-to-end consulting and implementation to ensure scalable, secure, and optimised Power Platform adoption:</p>
        

        <div className="bottom-sections-grid">
          <div className="how-we-help__cards">
            {[
              { icon: <Briefcase size={40} />, title: "Architecture & Advisory", desc: "Design Power Platform architecture aligned with your business strategy" },
              { icon: <Code size={40} />, title: "App Modernisation", desc: "Rebuild legacy workflows and apps into scalable low-code solutions" },
              { icon: <Smartphone size={40} />, title: "Governance & Security", desc: "Ensure compliance, role-based access, and safe citizen development" },
              { icon: <TrendingUp size={40} />, title: "Enterprise Integration", desc: "Integrate with SAP, Azure, Dynamics 365 and more across your ecosystem" }
            ].map((card, i) => (
              <div className="how-we-help__card" key={i} style={{ height: '190px', cursor: 'default' }}>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerPlatformServices;
